export default __webpack_public_path__ + "i18n/translations/translation-ko.bbf08e75.json";